import React, { useState, useEffect }  from 'react'
import plus from '../assets/+.svg'

function EditContractForm({category, taskID, entry, setLoading, setRefresh, setOpenPopup, openPopup, name, value, id}) {
  const [names, setName] = useState(name);
  const [values, setValue] = useState(value);
  useEffect(() => {
   setValue(values.toString()
   .replace(/\B(?=(\d{3})+(?!\d))/g, ','))
  }, [])
  function isFloat(value) {
    // Regular expression to match a floating-point number
    const floatRegex = /^[+-]?\d+(\.\d+)?$/;
  
    return floatRegex.test(value);
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if(!isFloat(parseFloat(values.replace(/,/g, ''))))
        return;
    console.log({names, values})
    console.log(entry)
    if(names.length ===0 || values == null ) return;
    fetch('/api-dev/expenses/UpdateMainBudgetLine/'+id,{
   method: "POST",
       body: JSON.stringify({ MainBudgetLineName:names, Value:parseFloat(values.replace(/,/g, ''))}),
        headers: {
          'Content-Type': 'application/json',
        },
     }).then(e=>console.log("updated in database") )
     setOpenPopup(false)
     setRefresh(prev => !prev)
    setLoading(true)
  }
  const handleChangeValue = (e) => {
    /*const inputValue = parseFloat(e.target.value);
    setValue(inputValue);*/
    const rawValue = e.target.value.replace(/,/g, ''); // Remove commas for processing
    const formattedValue = rawValue
  .toString()
  .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    setValue(formattedValue);
  };
  const handleChangeName = (e) => {
    setName(e.target.value);
  }
  return (
    <>
        <form onSubmit={handleSubmit}>
            <div className='form-input'>
                <label className='form-input-label'>Contract title*</label>
                <input value={names} onChange={handleChangeName} className='form-input-field' type="text" placeholder="Name" />
            </div>
            <div className='form-input' style={{marginTop:'30px'}}>
                <label className='form-input-label'>Allocated budget*</label>
                <input value={values} onChange={handleChangeValue} id="myNumberInput" className='form-input-field' type="text" placeholder="0,00" />
            </div>
            <div className='form-button' style={{marginTop:'40px'}}>
            <button style={{cursor:'pointer'}} type="submit" className='form-submit'>
                <img src={plus} alt="plus" className='form-submit-icon' />
                &nbsp;
                <span className='form-submit-text'>Edit contract</span>
            </button>
            </div>
        </form>
            
        </>
  )
}

export default EditContractForm